import moment from 'moment-timezone';

import { StoreState } from '../../interfaces';

export const initialStoreState: StoreState = {
  // Indicates whether user is authenticated
  allowChangePassword: false,

  // Container for EventTypes used for Events filtering
  // TODO -- rename this to: eventFilterEventTags
  eventTags: [],
  flags: [],

  timezone: moment.tz.guess(),

  // Indicates whether there is any async process fetching data
  isFetchingServerData: false,

  // Indicates whether any error was raised
  isErrorRaised: false,

  // What was the last error raised?
  lastErrorRaised: false,

  // This is needed to prevent reloading of the poster and the video in the midst of its playing in the player
  // after the mapEvents is reloaded by from the API. We need to deep copy the event here, so the Modal Window
  // component is not actually reloaded whenever the mapEvents is reloaded from the API.
  modalWindowEventId: null,

  editMatchesEventObject: null,

  fleet: null,

  // for superadmins, they can select a fleet that they're using at the moment to interact with the system.
  // for other users, its embedded in their access token
  currentSelectedFleetID: '',
};
